/**
 * Whether this admin-stock bundle is running inside the SMA print-settings
 * popup iframe.
 *
 * The SMA operation lists open a print-settings page in a same-origin iframe at
 * `/admin/<route>?embed=1` (stock-managment-app `PrintSettingsShortcut`). In
 * that context the popup should show ONLY the single opened page — no
 * cross-module tab navigation (Wastage Reasons / Items Lists / Print Settings
 * groups, nor the per-template sub-tabs). Standalone admin usage keeps the tabs.
 *
 * Detection is captured once at module load and cached on `window`, because the
 * layout later calls `history.replace(pathname)` which strips the query string.
 * Falls back to iframe detection (`window.self !== window.top`) since the popup
 * is the only context that frames this bundle.
 */
const detect = () => {
  if (typeof window === 'undefined') return false;
  if (window.__ADMIN_STOCK_EMBED__) return true;

  let flagged = false;
  try {
    flagged = new URLSearchParams(window.location.search).get('embed') === '1';
  } catch (e) {
    /* ignore malformed query */
  }
  if (!flagged) {
    try {
      flagged = window.self !== window.top;
    } catch (e) {
      // Cross-origin access throws → we are framed.
      flagged = true;
    }
  }

  if (flagged) window.__ADMIN_STOCK_EMBED__ = true;
  return Boolean(window.__ADMIN_STOCK_EMBED__);
};

const IS_EMBEDDED = detect();

export const isEmbedded = () =>
  (typeof window !== 'undefined' && Boolean(window.__ADMIN_STOCK_EMBED__)) || IS_EMBEDDED;

export default isEmbedded;
